import { adjustmentService, hubService, } from '@/services';
import HubDetailVM from '@/view-model/hub/HubDetailVM';
import WithholdTaxVM from '@/view-model/worker-adjustment/WithholdTaxVM';
export default {
    setFilterOption({ commit }, payload) {
        commit('SET_FILTER_OPTION', payload);
    },
    async getHubDetail({ commit }, hubId) {
        try {
            const res = await hubService.getHub(hubId);
            res.data = new HubDetailVM(res.data);
            commit('GET_HUB_INFO', res.data);
            return res.data;
        }
        catch (error) {
            console.log('[getHubDetail]', error);
            return error;
        }
    },
    async getWithholdTax({ commit, getters, rootGetters }) {
        const subscribeHubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const distributorId = rootGetters['hubSelector/getterSubscribeDistributorHubId'];
        let hubId = subscribeHubId;
        // 총판일 경우 hubId 변경
        if (distributorId) {
            hubId = distributorId;
        }
        const [fromAt, toAt,] = getters.getterSelectedMonthToTimeStamp;
        const res = await adjustmentService.getWorkerAdjustmentWithhold({
            hubId,
            fromAt,
            toAt,
        });
        res.data = new WithholdTaxVM(res.data);
        commit('GET_WITHHOLD_TAX', res.data);
        return res;
    },
};
